var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 896.15 178.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5455eb;\n      }\n\n      .cls-2 {\n        fill: #7651fd;\n      }\n\n      .cls-3 {\n        fill: #054da5;\n      }\n\n      .cls-4 {\n        fill: #032e71;\n      }\n\n      .cls-5 {\n        fill: #6e52f9;\n      }\n\n      .cls-6 {\n        fill: #043e8c;\n      }\n\n      .cls-7 {\n        fill: #043a86;\n      }\n\n      .cls-8 {\n        fill: #065ec2;\n      }\n\n      .cls-9 {\n        fill: #195ccc;\n      }\n\n      .cls-10 {\n        fill: #3059d8;\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-12 {\n        fill: #0554b2;\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-14 {\n        fill: #0c5dc5;\n      }\n\n      .cls-15 {\n        fill: #0f5dc7;\n      }\n\n      .cls-16 {\n        fill: #1f5bcf;\n      }\n\n      .cls-17 {\n        fill: #6353f3;\n      }\n\n      .cls-18 {\n        fill: #065cbf;\n      }\n\n      .cls-19 {\n        fill: #3858dc;\n      }\n\n      .cls-20 {\n        fill: #043985;\n      }\n\n      .cls-21 {\n        fill: #0555b3;\n      }\n\n      .cls-22 {\n        fill: #295ad5;\n      }\n\n      .cls-23 {\n        fill: #6953f6;\n      }\n\n      .cls-24 {\n        fill: #0656b4;\n      }\n\n      .cls-25 {\n        fill: #1a5ccc;\n      }\n\n      .cls-26 {\n        fill: #032a6b;\n      }\n\n      .cls-27 {\n        fill: #043279;\n      }\n\n      .cls-28 {\n        fill: #4657e4;\n      }\n\n      .cls-29 {\n        fill: #4557e3;\n      }\n\n      .cls-30 {\n        fill: #0551ad;\n      }\n\n      .cls-31 {\n        fill: #2d59d7;\n      }\n\n      .cls-32 {\n        fill: #4257e2;\n      }\n\n      .cls-33 {\n        fill: #3e58df;\n      }\n\n      .cls-34 {\n        fill: #5854ed;\n      }\n\n      .cls-35 {\n        fill: #4e56e8;\n      }\n\n      .cls-36 {\n        fill: #5755ed;\n      }\n\n      .cls-37 {\n        fill: #054aa0;\n      }\n\n      .cls-38 {\n        fill: #4357e2;\n      }\n\n      .cls-39 {\n        fill: #043781;\n      }\n\n      .cls-40 {\n        fill: #0b5dc5;\n      }\n\n      .cls-41 {\n        fill: #3f57e0;\n      }\n\n      .cls-42 {\n        fill: #175ccb;\n      }\n\n      .cls-43 {\n        fill: #2a5ad5;\n      }\n\n      .cls-44 {\n        fill: #6b52f7;\n      }\n\n      .cls-45 {\n        fill: #0554b1;\n      }\n\n      .cls-46 {\n        fill: #04357d;\n      }\n\n      .cls-47 {\n        fill: #6c52f8;\n      }\n\n      .cls-48 {\n        fill: #6054f1;\n      }\n\n      .cls-49 {\n        fill: #7351fc;\n      }\n\n      .cls-50 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-51 {\n        fill: #065abb;\n      }\n\n      .cls-52 {\n        fill: #032d6f;\n      }\n\n      .cls-53 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-54 {\n        fill: #5c54ef;\n      }\n\n      .cls-55 {\n        fill: #043d8a;\n      }\n\n      .cls-56 {\n        fill: #5155ea;\n      }\n\n      .cls-57 {\n        fill: #6f52f9;\n      }\n\n      .cls-58 {\n        opacity: .2;\n      }\n\n      .cls-59 {\n        fill: #054ca3;\n      }\n\n      .cls-60 {\n        fill: #032c6e;\n      }\n\n      .cls-61 {\n        fill: #032b6d;\n      }\n\n      .cls-62 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-63 {\n        fill: #043d8b;\n      }\n\n      .cls-64 {\n        fill: #04337b;\n      }\n\n      .cls-65 {\n        fill: #0656b5;\n      }\n\n      .cls-66 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-67 {\n        fill: #04357e;\n      }\n\n      .cls-68 {\n        fill: #235bd1;\n      }\n\n      .cls-69 {\n        fill: #04337a;\n      }\n\n      .cls-70 {\n        fill: #265ad3;\n      }\n\n      .cls-71 {\n        fill: #3658db;\n      }\n\n      .cls-72 {\n        fill: #043e8d;\n      }\n\n      .cls-73 {\n        fill: #125dc9;\n      }\n\n      .cls-74 {\n        fill: #0550aa;\n      }\n\n      .cls-75 {\n        fill: #054fa9;\n      }\n\n      .cls-76 {\n        fill: #7451fc;\n      }\n\n      .cls-77 {\n        fill: #044191;\n      }\n\n      .cls-78 {\n        fill: #032b6c;\n      }\n\n      .cls-79 {\n        fill: #4756e4;\n      }\n\n      .cls-80 {\n        fill: #43299a;\n      }\n\n      .cls-81 {\n        fill: #043984;\n      }\n\n      .cls-82 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-83 {\n        fill: #032e72;\n      }\n\n      .cls-84 {\n        fill: #065abc;\n      }\n\n      .cls-85 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-86 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-87 {\n        fill: #3c58de;\n      }\n\n      .cls-88 {\n        fill: #3958dd;\n      }\n\n      .cls-89 {\n        fill: #04408f;\n      }\n\n      .cls-90 {\n        fill: #5954ee;\n      }\n\n      .cls-91 {\n        fill: #5b54ef;\n      }\n\n      .cls-92 {\n        fill: #054ca4;\n      }\n\n      .cls-93 {\n        fill: #0550ab;\n      }\n\n      .cls-94 {\n        fill: #4157e1;\n      }\n\n      .cls-95 {\n        fill: #165cca;\n      }\n\n      .cls-96 {\n        fill: #043882;\n      }\n\n      .cls-97 {\n        fill: #054fa8;\n      }\n\n      .cls-98 {\n        fill: #0a5ec4;\n      }\n\n      .cls-99 {\n        fill: #065dc0;\n      }\n\n      .cls-100 {\n        fill: #5555ec;\n      }\n\n      .cls-101 {\n        fill: #0553b0;\n      }\n\n      .cls-102 {\n        fill: #225bd1;\n      }\n\n      .cls-103 {\n        fill: #085ec3;\n      }\n\n      .cls-104 {\n        fill: #054699;\n      }\n\n      .cls-105 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-106 {\n        fill: #1b5ccd;\n      }\n\n      .cls-107 {\n        fill: #6853f6;\n      }\n\n      .cls-108 {\n        fill: #2c5ad6;\n      }\n\n      .cls-109 {\n        fill: #2f59d8;\n      }\n\n      .cls-110 {\n        fill: #155cca;\n      }\n\n      .cls-111 {\n        fill: #04347c;\n      }\n\n      .cls-112 {\n        fill: #054497;\n      }\n\n      .cls-113 {\n        fill: #05489d;\n      }\n\n      .cls-114 {\n        fill: #4a56e6;\n      }\n\n      .cls-115 {\n        fill: #4b56e6;\n      }\n\n      .cls-116 {\n        fill: #04367f;\n      }\n\n      .cls-117 {\n        fill: #0551ac;\n      }\n\n      .cls-118 {\n        fill: #033176;\n      }\n\n      .cls-119 {\n        fill: #095ec4;\n      }\n\n      .cls-120 {\n        fill: #05469a;\n      }\n\n      .cls-121 {\n        fill: #03ede9;\n      }\n\n      .cls-122 {\n        fill: #05479b;\n      }\n\n      .cls-123 {\n        fill: #5055e9;\n      }\n\n      .cls-124 {\n        fill: #255ad2;\n      }\n\n      .cls-125 {\n        fill: #043b87;\n      }\n\n      .cls-126 {\n        fill: #0553af;\n      }\n\n      .cls-127 {\n        fill: #205bd0;\n      }\n\n      .cls-128 {\n        fill: #7551fd;\n      }\n\n      .cls-129 {\n        fill: #043c89;\n      }\n\n      .cls-130 {\n        fill: #3d58df;\n      }\n\n      .cls-131 {\n        fill: #185ccb;\n      }\n\n      .cls-132 {\n        fill: #105dc7;\n      }\n\n      .cls-133 {\n        fill: #3159d9;\n      }\n\n      .cls-134 {\n        fill: #fdab07;\n      }\n\n      .cls-135 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-136 {\n        fill: #245bd2;\n      }\n\n      .cls-137 {\n        fill: #3459da;\n      }\n\n      .cls-138 {\n        fill: #043883;\n      }\n\n      .cls-139 {\n        fill: #0657b7;\n      }\n\n      .cls-140 {\n        fill: #5d54f0;\n      }\n\n      .cls-141 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-142 {\n        fill: #145cc9;\n      }\n\n      .cls-143 {\n        fill: #5e54f0;\n      }\n\n      .cls-144 {\n        fill: #033278;\n      }\n\n      .cls-145 {\n        fill: #215bd0;\n      }\n\n      .cls-146 {\n        fill: #6153f2;\n      }\n\n      .cls-147 {\n        fill: #0657b6;\n      }\n\n      .cls-148 {\n        fill: #6753f5;\n      }\n\n      .cls-149 {\n        fill: #6453f3;\n      }\n\n      .cls-150 {\n        fill: #4057e0;\n      }\n\n      .cls-151 {\n        fill: #05499f;\n      }\n\n      .cls-152 {\n        fill: #6a52f7;\n      }\n\n      .cls-153 {\n        fill: #032f73;\n      }\n\n      .cls-154 {\n        fill: none;\n      }\n\n      .cls-155 {\n        fill: #285ad4;\n      }\n\n      .cls-156 {\n        fill: #4d56e7;\n      }\n\n      .cls-157 {\n        fill: #2b5ad6;\n      }\n\n      .cls-158 {\n        fill: #0d5dc6;\n      }\n\n      .cls-159 {\n        fill: #6d52f8;\n      }\n\n      .cls-160 {\n        fill: #044090;\n      }\n\n      .cls-161 {\n        fill: #0658b8;\n      }\n\n      .cls-162 {\n        fill: #0e5dc6;\n      }\n\n      .cls-163 {\n        fill: #4956e5;\n      }\n\n      .cls-164 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-165 {\n        fill: #3758dc;\n      }\n\n      .cls-166 {\n        fill: #6253f2;\n      }\n\n      .cls-167 {\n        fill: #7052fa;\n      }\n\n      .cls-168 {\n        fill: #032a6a;\n      }\n\n      .cls-169 {\n        fill: #6553f4;\n      }\n\n      .cls-170 {\n        fill: #05499e;\n      }\n\n      .cls-171 {\n        fill: #054496;\n      }\n\n      .cls-172 {\n        fill: #032d70;\n      }\n\n      .cls-173 {\n        fill: #7152fa;\n      }\n\n      .cls-174 {\n        fill: #4457e3;\n      }\n\n      .cls-175 {\n        fill: #7152fb;\n      }\n\n      .cls-176 {\n        fill: #043f8e;\n      }\n\n      .cls-177 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-178 {\n        fill: #fdcfcf;\n      }\n\n      .cls-179 {\n        fill: #3a58dd;\n      }\n\n      .cls-180 {\n        fill: #0659ba;\n      }\n\n      .cls-181 {\n        fill: #043b88;\n      }\n\n      .cls-182 {\n        fill: #5f54f1;\n      }\n\n      .cls-183 {\n        fill: #043680;\n      }\n\n      .cls-184 {\n        fill: #054ba2;\n      }\n\n      .cls-185 {\n        fill: #5255ea;\n      }\n\n      .cls-186 {\n        fill: #5a54ee;\n      }\n\n      .cls-187 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-188 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-189 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-190 {\n        fill: #044192;\n      }\n\n      .cls-191 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-192 {\n        fill: #044293;\n      }\n\n      .cls-193 {\n        fill: #5355eb;\n      }\n\n      .cls-194 {\n        fill: #0658b9;\n      }\n\n      .cls-195 {\n        fill: #054aa1;\n      }\n\n      .cls-196 {\n        fill: #275ad3;\n      }\n\n      .cls-197 {\n        fill: #1c5bcd;\n      }\n\n      .cls-198 {\n        fill: #054598;\n      }\n\n      .cls-199 {\n        fill: #033075;\n      }\n\n      .cls-200 {\n        fill: #7251fb;\n      }\n\n      .cls-201 {\n        fill: #00b3f2;\n      }\n\n      .cls-202 {\n        fill: #05479c;\n      }\n\n      .cls-203 {\n        fill: #1e5bcf;\n      }\n\n      .cls-204 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-205 {\n        fill: #1d5bce;\n      }\n\n      .cls-206 {\n        fill: #2e59d7;\n      }\n\n      .cls-207 {\n        fill: #4f56e8;\n      }\n\n      .cls-208 {\n        fill: #6653f5;\n      }\n\n      .cls-209 {\n        fill: #4c56e7;\n      }\n\n      .cls-210 {\n        fill: #065bbd;\n      }\n\n      .cls-211 {\n        fill: #3559db;\n      }\n\n      .cls-212 {\n        fill: #044395;\n      }\n\n      .cls-213 {\n        fill: #3b58de;\n      }\n\n      .cls-214 {\n        fill: #044394;\n      }\n\n      .cls-215 {\n        fill: #115dc8;\n      }\n\n      .cls-216 {\n        fill: #4856e5;\n      }\n\n      .cls-217 {\n        fill: #065cbe;\n      }\n\n      .cls-218 {\n        fill: #3359d9;\n      }\n\n      .cls-219 {\n        fill: #0552ae;\n      }\n\n      .cls-220 {\n        fill: #054da6;\n      }\n\n      .cls-221 {\n        fill: #033074;\n      }\n\n      .cls-222 {\n        fill: #065dc1;\n      }\n\n      .cls-223 {\n        fill: #054ea7;\n      }\n\n      .cls-224 {\n        fill: #5655ec;\n      }\n\n      .cls-225 {\n        fill: #075ec3;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M301.66,102.54h21.07v16.54h-42.94V49.37h21.86v53.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M383.1,95.16h-35.16c.33,4.79,2.33,7.19,6.01,7.19,2.36,0,4.07-1.08,5.12-3.25h23.14c-.79,3.94-2.45,7.47-4.97,10.58-2.53,3.12-5.71,5.58-9.55,7.39-3.84,1.81-8.06,2.71-12.65,2.71-5.52,0-10.42-1.15-14.72-3.45-4.3-2.3-7.65-5.6-10.04-9.9-2.4-4.3-3.59-9.34-3.59-15.12s1.2-10.82,3.59-15.12c2.4-4.3,5.74-7.6,10.04-9.9,4.3-2.3,9.21-3.45,14.72-3.45s10.42,1.13,14.72,3.4c4.3,2.27,7.65,5.5,10.04,9.7,2.39,4.2,3.59,9.16,3.59,14.87,0,1.51-.1,2.95-.29,4.33Zm-21.86-9.55c0-1.84-.59-3.23-1.77-4.18-1.18-.95-2.66-1.43-4.43-1.43-3.88,0-6.14,1.87-6.8,5.61h13Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M418.45,98.31l8.86-34.76h23.24l-18.51,55.54h-27.28l-18.51-55.54h23.24l8.96,34.76Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M509.84,95.16h-35.16c.33,4.79,2.33,7.19,6.01,7.19,2.36,0,4.07-1.08,5.12-3.25h23.14c-.79,3.94-2.45,7.47-4.97,10.58-2.53,3.12-5.71,5.58-9.55,7.39-3.84,1.81-8.06,2.71-12.65,2.71-5.52,0-10.42-1.15-14.72-3.45-4.3-2.3-7.65-5.6-10.04-9.9-2.4-4.3-3.59-9.34-3.59-15.12s1.2-10.82,3.59-15.12c2.4-4.3,5.74-7.6,10.04-9.9,4.3-2.3,9.21-3.45,14.72-3.45s10.42,1.13,14.72,3.4c4.3,2.27,7.65,5.5,10.04,9.7,2.39,4.2,3.59,9.16,3.59,14.87,0,1.51-.1,2.95-.29,4.33Zm-21.86-9.55c0-1.84-.59-3.23-1.77-4.18-1.18-.95-2.66-1.43-4.43-1.43-3.88,0-6.14,1.87-6.8,5.61h13Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M538.89,46.21V119.09h-21.86V46.21h21.86Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M570.1,49.37v39.29c0,3.22,.71,5.76,2.12,7.63,1.41,1.87,3.69,2.81,6.85,2.81s5.48-.94,6.99-2.81c1.51-1.87,2.26-4.42,2.26-7.63V49.37h21.76v39.29c0,6.63-1.38,12.29-4.14,16.99-2.76,4.69-6.53,8.22-11.33,10.59-4.79,2.36-10.14,3.55-16.05,3.55s-11.14-1.18-15.71-3.55c-4.56-2.36-8.12-5.87-10.69-10.54-2.56-4.66-3.84-10.34-3.84-17.04V49.37h21.76Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M647.36,65.07c2.59-1.48,5.69-2.22,9.31-2.22,4.33,0,8.24,1.13,11.72,3.4,3.48,2.27,6.22,5.55,8.22,9.85,2,4.3,3,9.37,3,15.22s-1,10.92-3,15.21c-2,4.3-4.74,7.58-8.22,9.85-3.48,2.27-7.39,3.4-11.72,3.4-3.61,0-6.71-.74-9.31-2.22-2.59-1.48-4.58-3.5-5.96-6.06v34.17h-21.86V63.55h21.86v7.58c1.38-2.56,3.36-4.58,5.96-6.06Zm7.83,19.35c-1.51-1.64-3.45-2.46-5.81-2.46s-4.3,.82-5.81,2.46c-1.51,1.64-2.26,3.94-2.26,6.89s.75,5.25,2.26,6.89,3.45,2.46,5.81,2.46,4.3-.82,5.81-2.46,2.26-3.94,2.26-6.89-.75-5.25-2.26-6.89Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M708.36,102.54h21.07v16.54h-42.94V49.37h21.86v53.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M747.65,116.33c-4.47-2.3-7.96-5.6-10.49-9.9-2.53-4.3-3.79-9.34-3.79-15.12s1.26-10.82,3.79-15.12c2.53-4.3,6.02-7.6,10.49-9.9,4.46-2.3,9.49-3.45,15.07-3.45s10.6,1.15,15.07,3.45c4.46,2.3,7.96,5.6,10.49,9.9,2.53,4.3,3.79,9.34,3.79,15.12s-1.26,10.82-3.79,15.12c-2.53,4.3-6.02,7.6-10.49,9.9-4.47,2.3-9.49,3.45-15.07,3.45s-10.6-1.15-15.07-3.45Zm20.19-17.87c1.38-1.61,2.07-3.99,2.07-7.14s-.69-5.53-2.07-7.14c-1.38-1.61-3.09-2.41-5.12-2.41s-3.74,.8-5.12,2.41c-1.38,1.61-2.07,3.99-2.07,7.14s.67,5.53,2.02,7.14c1.34,1.61,3.07,2.41,5.17,2.41s3.74-.8,5.12-2.41Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M810.28,116.33c-4.47-2.3-7.96-5.6-10.49-9.9-2.53-4.3-3.79-9.34-3.79-15.12s1.26-10.82,3.79-15.12c2.53-4.3,6.02-7.6,10.49-9.9,4.46-2.3,9.49-3.45,15.07-3.45s10.6,1.15,15.07,3.45c4.46,2.3,7.96,5.6,10.49,9.9,2.53,4.3,3.79,9.34,3.79,15.12s-1.26,10.82-3.79,15.12c-2.53,4.3-6.02,7.6-10.49,9.9-4.47,2.3-9.49,3.45-15.07,3.45s-10.6-1.15-15.07-3.45Zm20.19-17.87c1.38-1.61,2.07-3.99,2.07-7.14s-.69-5.53-2.07-7.14c-1.38-1.61-3.09-2.41-5.12-2.41s-3.74,.8-5.12,2.41c-1.38,1.61-2.07,3.99-2.07,7.14s.67,5.53,2.02,7.14c1.34,1.61,3.07,2.41,5.17,2.41s3.74-.8,5.12-2.41Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M896.15,100.48v18.61h-8.27c-15.23,0-22.85-7.58-22.85-22.75v-14.57h-6.89v-18.22h6.89v-13.39h21.86v13.39h9.06v18.22h-9.06v14.97c0,1.31,.31,2.26,.94,2.86,.62,.59,1.66,.89,3.1,.89h5.22Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M249.36,115.55l-29.46-83.61c-3.34-9.49-12.31-15.84-22.38-15.84H53.76c-10.06,0-19.03,6.35-22.38,15.84L1.92,115.55c-7.63,21.67,8.44,44.38,31.42,44.38h0c10.28,0,19.98-4.75,26.29-12.86l19.1-24.56c11.26-14.47,28.57-22.94,46.91-22.94h0c18.34,0,35.65,8.47,46.91,22.94l19.1,24.56c6.31,8.11,16.01,12.86,26.29,12.86h0c22.97,0,39.05-22.71,31.42-44.38Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M249.36,115.55l-29.46-83.61c-.63-1.78-1.45-3.45-2.44-4.99-4.3-6.66-11.76-10.86-19.93-10.86H53.76c-6.92,0-13.32,3-17.73,7.96-2.01,2.25-3.6,4.91-4.65,7.88L1.92,115.55c-3.9,11.07-1.6,22.41,4.64,30.85l35.16-58.49c5.35-8.89,17.04-11.52,25.66-5.75,14.75,9.87,32.14,16.1,50.89,17.4h14.73c19.12-1.33,36.83-7.78,51.76-17.99,9.26-6.33,21.94-3.27,27.03,6.73l30.84,60.67c7.78-8.62,11.03-21.19,6.72-33.42Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M70.28,100.03c-26.56,0-48.18-21.61-48.18-48.18S43.71,3.67,70.28,3.67s48.18,21.61,48.18,48.18-21.61,48.18-48.18,48.18Zm0-90.58c-23.38,0-42.4,19.02-42.4,42.4s19.02,42.4,42.4,42.4,42.4-19.02,42.4-42.4S93.66,9.45,70.28,9.45Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M181,100.03c-26.56,0-48.18-21.61-48.18-48.18S154.44,3.67,181,3.67s48.18,21.61,48.18,48.18-21.61,48.18-48.18,48.18Zm0-90.58c-23.38,0-42.4,19.02-42.4,42.4s19.02,42.4,42.4,42.4,42.4-19.02,42.4-42.4-19.02-42.4-42.4-42.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M137.27,38.09c-13.27-7.81-22.81-.32-22.9-.24l-3.63-4.5c.51-.42,12.78-10.06,29.46-.24l-2.93,4.98Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M233.36,43.14h-7.07v5.78h7.07c1.6,0,2.89-1.29,2.89-2.89s-1.29-2.89-2.89-2.89Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M17.92,43.14c-1.6,0-2.89,1.29-2.89,2.89s1.29,2.89,2.89,2.89h7.07v-5.78h-7.07Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M147.7,123.34c-11.45,17.79-36.48,17.53-47.64-.39-2.11-3.38-7.47-.27-5.35,3.13,13.67,21.94,44.38,22.11,58.34,.39,2.17-3.37-3.2-6.48-5.35-3.13h0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-134",
    cx: 167.46,
    cy: 163.7,
    r: 14.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M301.66,102.54h21.07v16.54h-42.94V49.37h21.86v53.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1,95.16h-35.16c.33,4.79,2.33,7.19,6.01,7.19,2.36,0,4.07-1.08,5.12-3.25h23.14c-.79,3.94-2.45,7.47-4.97,10.59-2.53,3.12-5.71,5.58-9.55,7.39-3.84,1.81-8.06,2.71-12.65,2.71-5.51,0-10.42-1.15-14.72-3.45-4.3-2.3-7.65-5.6-10.04-9.9-2.4-4.3-3.59-9.34-3.59-15.12s1.2-10.82,3.59-15.12c2.4-4.3,5.74-7.6,10.04-9.9,4.3-2.3,9.21-3.45,14.72-3.45s10.42,1.13,14.72,3.4c4.3,2.27,7.65,5.5,10.04,9.7,2.4,4.2,3.59,9.16,3.59,14.87,0,1.51-.1,2.95-.29,4.33Zm-21.86-9.55c0-1.84-.59-3.23-1.77-4.19-1.18-.95-2.66-1.43-4.43-1.43-3.88,0-6.14,1.87-6.79,5.61h13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.45,98.31l8.86-34.76h23.24l-18.51,55.54h-27.28l-18.51-55.54h23.24l8.96,34.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.83,95.16h-35.16c.33,4.79,2.33,7.19,6.01,7.19,2.36,0,4.07-1.08,5.12-3.25h23.14c-.79,3.94-2.45,7.47-4.97,10.59-2.53,3.12-5.71,5.58-9.55,7.39-3.84,1.81-8.06,2.71-12.65,2.71-5.51,0-10.42-1.15-14.72-3.45-4.3-2.3-7.65-5.6-10.04-9.9-2.4-4.3-3.59-9.34-3.59-15.12s1.2-10.82,3.59-15.12c2.4-4.3,5.74-7.6,10.04-9.9,4.3-2.3,9.21-3.45,14.72-3.45s10.42,1.13,14.72,3.4c4.3,2.27,7.65,5.5,10.04,9.7,2.4,4.2,3.59,9.16,3.59,14.87,0,1.51-.1,2.95-.29,4.33Zm-21.86-9.55c0-1.84-.59-3.23-1.77-4.19-1.18-.95-2.66-1.43-4.43-1.43-3.88,0-6.14,1.87-6.79,5.61h13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.88,46.22V119.09h-21.86V46.22h21.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.1,49.37v39.29c0,3.22,.71,5.76,2.12,7.63,1.41,1.87,3.69,2.81,6.84,2.81s5.48-.94,6.99-2.81c1.51-1.87,2.26-4.41,2.26-7.63V49.37h21.76v39.29c0,6.63-1.38,12.29-4.14,16.99-2.76,4.69-6.53,8.22-11.33,10.59-4.79,2.36-10.14,3.54-16.05,3.54s-11.14-1.18-15.71-3.54c-4.56-2.36-8.12-5.88-10.68-10.54-2.56-4.66-3.84-10.34-3.84-17.04V49.37h21.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.35,65.07c2.59-1.48,5.69-2.22,9.31-2.22,4.33,0,8.24,1.13,11.72,3.4,3.48,2.27,6.22,5.55,8.22,9.85,2,4.3,3,9.37,3,15.21s-1,10.92-3,15.21c-2,4.3-4.74,7.58-8.22,9.85-3.48,2.26-7.39,3.4-11.72,3.4-3.61,0-6.71-.74-9.31-2.22-2.59-1.48-4.58-3.5-5.96-6.06v34.17h-21.86V63.55h21.86v7.58c1.38-2.56,3.36-4.58,5.96-6.06Zm7.83,19.35c-1.51-1.64-3.45-2.46-5.81-2.46s-4.3,.82-5.81,2.46c-1.51,1.64-2.27,3.94-2.27,6.89s.75,5.25,2.27,6.89c1.51,1.64,3.45,2.46,5.81,2.46s4.3-.82,5.81-2.46c1.51-1.64,2.26-3.94,2.26-6.89s-.75-5.25-2.26-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.36,102.54h21.07v16.54h-42.94V49.37h21.86v53.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.65,116.33c-4.47-2.3-7.96-5.6-10.49-9.9-2.53-4.3-3.79-9.34-3.79-15.12s1.26-10.82,3.79-15.12c2.53-4.3,6.02-7.6,10.49-9.9,4.46-2.3,9.49-3.45,15.07-3.45s10.6,1.15,15.07,3.45c4.46,2.3,7.96,5.6,10.49,9.9,2.53,4.3,3.79,9.34,3.79,15.12s-1.26,10.82-3.79,15.12c-2.53,4.3-6.02,7.6-10.49,9.9-4.46,2.3-9.49,3.45-15.07,3.45s-10.6-1.15-15.07-3.45Zm20.19-17.87c1.38-1.61,2.07-3.99,2.07-7.14s-.69-5.53-2.07-7.14c-1.38-1.61-3.09-2.41-5.12-2.41s-3.74,.8-5.12,2.41c-1.38,1.61-2.07,3.99-2.07,7.14s.67,5.53,2.02,7.14c1.34,1.61,3.07,2.41,5.17,2.41s3.74-.8,5.12-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.28,116.33c-4.47-2.3-7.96-5.6-10.49-9.9-2.53-4.3-3.79-9.34-3.79-15.12s1.26-10.82,3.79-15.12c2.53-4.3,6.02-7.6,10.49-9.9,4.46-2.3,9.49-3.45,15.07-3.45s10.6,1.15,15.07,3.45c4.46,2.3,7.96,5.6,10.49,9.9,2.53,4.3,3.79,9.34,3.79,15.12s-1.26,10.82-3.79,15.12c-2.53,4.3-6.02,7.6-10.49,9.9-4.46,2.3-9.49,3.45-15.07,3.45s-10.6-1.15-15.07-3.45Zm20.19-17.87c1.38-1.61,2.07-3.99,2.07-7.14s-.69-5.53-2.07-7.14c-1.38-1.61-3.09-2.41-5.12-2.41s-3.74,.8-5.12,2.41c-1.38,1.61-2.07,3.99-2.07,7.14s.67,5.53,2.02,7.14c1.34,1.61,3.07,2.41,5.17,2.41s3.74-.8,5.12-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.15,100.48v18.61h-8.27c-15.23,0-22.85-7.58-22.85-22.75v-14.57h-6.89v-18.22h6.89v-13.39h21.86v13.39h9.06v18.22h-9.06v14.97c0,1.31,.31,2.27,.94,2.86,.62,.59,1.66,.89,3.1,.89h5.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 279.8,
    y: 119.03,
    width: 42.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 279.8,
    y: 118.15,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 279.8,
    y: 117.26,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 279.8,
    y: 116.37,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 279.8,
    y: 115.48,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 279.8,
    y: 114.59,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 279.8,
    y: 113.71,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 279.8,
    y: 112.82,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 279.8,
    y: 111.93,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 279.8,
    y: 111.04,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 279.8,
    y: 110.15,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 279.8,
    y: 109.27,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 279.8,
    y: 108.38,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 279.8,
    y: 107.49,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 279.8,
    y: 106.6,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 279.8,
    y: 105.71,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 279.8,
    y: 104.83,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 279.8,
    y: 103.94,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 279.8,
    y: 103.05,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 279.8,
    y: 102.16,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 279.8,
    y: 101.27,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 279.8,
    y: 100.39,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 279.8,
    y: 99.5,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 279.8,
    y: 98.61,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 279.8,
    y: 97.72,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 279.8,
    y: 96.83,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 279.8,
    y: 95.95,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 279.8,
    y: 95.06,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 279.8,
    y: 94.17,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 279.8,
    y: 93.28,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 279.8,
    y: 92.39,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 279.8,
    y: 91.51,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 279.8,
    y: 90.62,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 279.8,
    y: 89.73,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 279.8,
    y: 88.84,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 279.8,
    y: 87.95,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 279.8,
    y: 87.06,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 279.8,
    y: 86.18,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 279.8,
    y: 85.29,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 279.8,
    y: 84.4,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 279.8,
    y: 83.51,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 279.8,
    y: 82.62,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 279.8,
    y: 81.74,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 279.8,
    y: 80.85,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 279.8,
    y: 79.96,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 279.8,
    y: 79.07,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 279.8,
    y: 78.18,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 279.8,
    y: 77.3,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 279.8,
    y: 76.41,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 279.8,
    y: 75.52,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 279.8,
    y: 74.63,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 279.8,
    y: 73.74,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 279.8,
    y: 72.86,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 279.8,
    y: 71.97,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 279.8,
    y: 71.08,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 279.8,
    y: 70.19,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 279.8,
    y: 69.3,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 279.8,
    y: 68.42,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 279.8,
    y: 67.53,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 279.8,
    y: 66.64,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 279.8,
    y: 65.75,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 279.8,
    y: 64.86,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 279.8,
    y: 63.98,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 279.8,
    y: 63.09,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 279.8,
    y: 62.2,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 279.8,
    y: 61.31,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 279.8,
    y: 60.42,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 279.8,
    y: 59.54,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 279.8,
    y: 58.65,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 279.8,
    y: 57.76,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 279.8,
    y: 56.87,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 279.8,
    y: 55.98,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 279.8,
    y: 55.1,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 279.8,
    y: 54.21,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 279.8,
    y: 53.32,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 279.8,
    y: 52.43,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 279.8,
    y: 51.54,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 279.8,
    y: 50.65,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 279.8,
    y: 49.77,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 279.8,
    y: 49.37,
    width: 42.94,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 348.24,
    y: 85.29,
    width: 13,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 348.24,
    y: 84.4,
    width: 13,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 348.24,
    y: 83.51,
    width: 13,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 348.24,
    y: 82.62,
    width: 13,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 348.24,
    y: 81.74,
    width: 13,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 348.24,
    y: 80.85,
    width: 13,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 348.24,
    y: 79.99,
    width: 13,
    height: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 326.67,
    y: 119.03,
    width: 56.72,
    height: 0.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 326.67,
    y: 118.15,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 326.67,
    y: 117.26,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 326.67,
    y: 116.37,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 326.67,
    y: 115.48,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 326.67,
    y: 114.59,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 326.67,
    y: 113.71,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 326.67,
    y: 112.82,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 326.67,
    y: 111.93,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 326.67,
    y: 111.04,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 326.67,
    y: 110.15,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 326.67,
    y: 109.27,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 326.67,
    y: 108.38,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 326.67,
    y: 107.49,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 326.67,
    y: 106.6,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 326.67,
    y: 105.71,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 326.67,
    y: 104.83,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 326.67,
    y: 103.94,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 326.67,
    y: 103.05,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 326.67,
    y: 102.16,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 326.67,
    y: 101.27,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 326.67,
    y: 100.39,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 326.67,
    y: 99.5,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 326.67,
    y: 98.61,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 326.67,
    y: 97.72,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 326.67,
    y: 96.83,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 326.67,
    y: 95.95,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 326.67,
    y: 95.06,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 326.67,
    y: 94.17,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 326.67,
    y: 93.28,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 326.67,
    y: 92.39,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 326.67,
    y: 91.51,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 326.67,
    y: 90.62,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 326.67,
    y: 89.73,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 326.67,
    y: 88.84,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 326.67,
    y: 87.95,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 326.67,
    y: 87.06,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 326.67,
    y: 86.18,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 326.67,
    y: 85.29,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 326.67,
    y: 84.4,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 326.67,
    y: 83.51,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 326.67,
    y: 82.62,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 326.67,
    y: 81.74,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 326.67,
    y: 80.85,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 326.67,
    y: 79.96,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 326.67,
    y: 79.07,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 326.67,
    y: 78.18,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 326.67,
    y: 77.3,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 326.67,
    y: 76.41,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 326.67,
    y: 75.52,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 326.67,
    y: 74.63,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 326.67,
    y: 73.74,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 326.67,
    y: 72.86,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 326.67,
    y: 71.97,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 326.67,
    y: 71.08,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 326.67,
    y: 70.19,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 326.67,
    y: 69.3,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 326.67,
    y: 68.42,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 326.67,
    y: 67.53,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 326.67,
    y: 66.64,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 326.67,
    y: 65.75,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 326.67,
    y: 64.86,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 326.67,
    y: 63.98,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 326.67,
    y: 63.09,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 326.67,
    y: 62.86,
    width: 56.72,
    height: 0.23
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 386.25,
    y: 119.03,
    width: 64.3,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 386.25,
    y: 118.15,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 386.25,
    y: 117.26,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 386.25,
    y: 116.37,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 386.25,
    y: 115.48,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 386.25,
    y: 114.59,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 386.25,
    y: 113.71,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 386.25,
    y: 112.82,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 386.25,
    y: 111.93,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 386.25,
    y: 111.04,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 386.25,
    y: 110.15,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 386.25,
    y: 109.27,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 386.25,
    y: 108.38,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 386.25,
    y: 107.49,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 386.25,
    y: 106.6,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 386.25,
    y: 105.71,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 386.25,
    y: 104.83,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 386.25,
    y: 103.94,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 386.25,
    y: 103.05,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 386.25,
    y: 102.16,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 386.25,
    y: 101.27,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 386.25,
    y: 100.39,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 386.25,
    y: 99.5,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 386.25,
    y: 98.61,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 386.25,
    y: 97.72,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 386.25,
    y: 96.83,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 386.25,
    y: 95.95,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 386.25,
    y: 95.06,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 386.25,
    y: 94.17,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 386.25,
    y: 93.28,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 386.25,
    y: 92.39,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 386.25,
    y: 91.51,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 386.25,
    y: 90.62,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 386.25,
    y: 89.73,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 386.25,
    y: 88.84,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 386.25,
    y: 87.95,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 386.25,
    y: 87.06,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 386.25,
    y: 86.18,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 386.25,
    y: 85.29,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 386.25,
    y: 84.4,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 386.25,
    y: 83.51,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 386.25,
    y: 82.62,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 386.25,
    y: 81.74,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 386.25,
    y: 80.85,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 386.25,
    y: 79.96,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 386.25,
    y: 79.07,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 386.25,
    y: 78.18,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 386.25,
    y: 77.3,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 386.25,
    y: 76.41,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 386.25,
    y: 75.52,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 386.25,
    y: 74.63,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 386.25,
    y: 73.74,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 386.25,
    y: 72.86,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 386.25,
    y: 71.97,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 386.25,
    y: 71.08,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 386.25,
    y: 70.19,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 386.25,
    y: 69.3,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 386.25,
    y: 68.42,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 386.25,
    y: 67.53,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 386.25,
    y: 66.64,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 386.25,
    y: 65.75,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 386.25,
    y: 64.86,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 386.25,
    y: 63.98,
    width: 64.3,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 386.25,
    y: 63.55,
    width: 64.3,
    height: 0.43
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 474.97,
    y: 85.29,
    width: 13,
    height: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 474.97,
    y: 84.4,
    width: 13,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 474.97,
    y: 83.51,
    width: 13,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 474.97,
    y: 82.62,
    width: 13,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 474.97,
    y: 81.74,
    width: 13,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 474.97,
    y: 80.85,
    width: 13,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 474.97,
    y: 79.99,
    width: 13,
    height: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 453.41,
    y: 119.03,
    width: 56.72,
    height: 0.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 453.41,
    y: 118.15,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 453.41,
    y: 117.26,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 453.41,
    y: 116.37,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 453.41,
    y: 115.48,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 453.41,
    y: 114.59,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 453.41,
    y: 113.71,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 453.41,
    y: 112.82,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 453.41,
    y: 111.93,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 453.41,
    y: 111.04,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 453.41,
    y: 110.15,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 453.41,
    y: 109.27,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 453.41,
    y: 108.38,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 453.41,
    y: 107.49,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 453.41,
    y: 106.6,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 453.41,
    y: 105.71,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 453.41,
    y: 104.83,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 453.41,
    y: 103.94,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 453.41,
    y: 103.05,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 453.41,
    y: 102.16,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 453.41,
    y: 101.27,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 453.41,
    y: 100.39,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 453.41,
    y: 99.5,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 453.41,
    y: 98.61,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 453.41,
    y: 97.72,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 453.41,
    y: 96.83,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 453.41,
    y: 95.95,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 453.41,
    y: 95.06,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 453.41,
    y: 94.17,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 453.41,
    y: 93.28,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 453.41,
    y: 92.39,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 453.41,
    y: 91.51,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 453.41,
    y: 90.62,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 453.41,
    y: 89.73,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 453.41,
    y: 88.84,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 453.41,
    y: 87.95,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 453.41,
    y: 87.06,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 453.41,
    y: 86.18,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 453.41,
    y: 85.29,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 453.41,
    y: 84.4,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 453.41,
    y: 83.51,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 453.41,
    y: 82.62,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 453.41,
    y: 81.74,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 453.41,
    y: 80.85,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 453.41,
    y: 79.96,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 453.41,
    y: 79.07,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 453.41,
    y: 78.18,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 453.41,
    y: 77.3,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 453.41,
    y: 76.41,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 453.41,
    y: 75.52,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 453.41,
    y: 74.63,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 453.41,
    y: 73.74,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 453.41,
    y: 72.86,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 453.41,
    y: 71.97,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 453.41,
    y: 71.08,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 453.41,
    y: 70.19,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 453.41,
    y: 69.3,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 453.41,
    y: 68.42,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 453.41,
    y: 67.53,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 453.41,
    y: 66.64,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 453.41,
    y: 65.75,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 453.41,
    y: 64.86,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 453.41,
    y: 63.98,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 453.41,
    y: 63.09,
    width: 56.72,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 453.41,
    y: 62.86,
    width: 56.72,
    height: 0.23
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 517.02,
    y: 119.03,
    width: 21.86,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 517.02,
    y: 118.15,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 517.02,
    y: 117.26,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 517.02,
    y: 116.37,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 517.02,
    y: 115.48,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 517.02,
    y: 114.59,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 517.02,
    y: 113.71,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 517.02,
    y: 112.82,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 517.02,
    y: 111.93,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 517.02,
    y: 111.04,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 517.02,
    y: 110.15,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 517.02,
    y: 109.27,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 517.02,
    y: 108.38,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 517.02,
    y: 107.49,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 517.02,
    y: 106.6,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 517.02,
    y: 105.71,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 517.02,
    y: 104.83,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 517.02,
    y: 103.94,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 517.02,
    y: 103.05,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 517.02,
    y: 102.16,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 517.02,
    y: 101.27,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 517.02,
    y: 100.39,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 517.02,
    y: 99.5,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 517.02,
    y: 98.61,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 517.02,
    y: 97.72,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 517.02,
    y: 96.83,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 517.02,
    y: 95.95,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 517.02,
    y: 95.06,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 517.02,
    y: 94.17,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 517.02,
    y: 93.28,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 517.02,
    y: 92.39,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 517.02,
    y: 91.51,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 517.02,
    y: 90.62,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 517.02,
    y: 89.73,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 517.02,
    y: 88.84,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 517.02,
    y: 87.95,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 517.02,
    y: 87.06,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 517.02,
    y: 86.18,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 517.02,
    y: 85.29,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 517.02,
    y: 84.4,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 517.02,
    y: 83.51,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 517.02,
    y: 82.62,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 517.02,
    y: 81.74,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 517.02,
    y: 80.85,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 517.02,
    y: 79.96,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 517.02,
    y: 79.07,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 517.02,
    y: 78.18,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 517.02,
    y: 77.3,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 517.02,
    y: 76.41,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 517.02,
    y: 75.52,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 517.02,
    y: 74.63,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 517.02,
    y: 73.74,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 517.02,
    y: 72.86,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 517.02,
    y: 71.97,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 517.02,
    y: 71.08,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 517.02,
    y: 70.19,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 517.02,
    y: 69.3,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 517.02,
    y: 68.42,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 517.02,
    y: 67.53,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 517.02,
    y: 66.64,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 517.02,
    y: 65.75,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 517.02,
    y: 64.86,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 517.02,
    y: 63.98,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 517.02,
    y: 63.09,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 517.02,
    y: 62.2,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 517.02,
    y: 61.31,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 517.02,
    y: 60.42,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 517.02,
    y: 59.54,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 517.02,
    y: 58.65,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 517.02,
    y: 57.76,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 517.02,
    y: 56.87,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 517.02,
    y: 55.98,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 517.02,
    y: 55.1,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 517.02,
    y: 54.21,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 517.02,
    y: 53.32,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 517.02,
    y: 52.43,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 517.02,
    y: 51.54,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 517.02,
    y: 50.65,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 517.02,
    y: 49.77,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 517.02,
    y: 48.88,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 517.02,
    y: 47.99,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 517.02,
    y: 47.1,
    width: 21.86,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 517.02,
    y: 46.21,
    width: 21.86,
    height: 0.89
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 548.34,
    y: 119.03,
    width: 61.74,
    height: 0.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 548.34,
    y: 118.15,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 548.34,
    y: 117.26,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 548.34,
    y: 116.37,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 548.34,
    y: 115.48,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 548.34,
    y: 114.59,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 548.34,
    y: 113.71,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 548.34,
    y: 112.82,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 548.34,
    y: 111.93,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 548.34,
    y: 111.04,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 548.34,
    y: 110.15,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 548.34,
    y: 109.27,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 548.34,
    y: 108.38,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 548.34,
    y: 107.49,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 548.34,
    y: 106.6,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 548.34,
    y: 105.71,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 548.34,
    y: 104.83,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 548.34,
    y: 103.94,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 548.34,
    y: 103.05,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 548.34,
    y: 102.16,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 548.34,
    y: 101.27,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 548.34,
    y: 100.39,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 548.34,
    y: 99.5,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 548.34,
    y: 98.61,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 548.34,
    y: 97.72,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 548.34,
    y: 96.83,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 548.34,
    y: 95.95,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 548.34,
    y: 95.06,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 548.34,
    y: 94.17,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 548.34,
    y: 93.28,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 548.34,
    y: 92.39,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 548.34,
    y: 91.51,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 548.34,
    y: 90.62,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 548.34,
    y: 89.73,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 548.34,
    y: 88.84,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 548.34,
    y: 87.95,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 548.34,
    y: 87.06,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 548.34,
    y: 86.18,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 548.34,
    y: 85.29,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 548.34,
    y: 84.4,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 548.34,
    y: 83.51,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 548.34,
    y: 82.62,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 548.34,
    y: 81.74,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 548.34,
    y: 80.85,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 548.34,
    y: 79.96,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 548.34,
    y: 79.07,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 548.34,
    y: 78.18,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 548.34,
    y: 77.3,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 548.34,
    y: 76.41,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 548.34,
    y: 75.52,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 548.34,
    y: 74.63,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 548.34,
    y: 73.74,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 548.34,
    y: 72.86,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 548.34,
    y: 71.97,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 548.34,
    y: 71.08,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 548.34,
    y: 70.19,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 548.34,
    y: 69.3,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 548.34,
    y: 68.42,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 548.34,
    y: 67.53,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 548.34,
    y: 66.64,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 548.34,
    y: 65.75,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 548.34,
    y: 64.86,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 548.34,
    y: 63.98,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 548.34,
    y: 63.09,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 548.34,
    y: 62.2,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 548.34,
    y: 61.31,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 548.34,
    y: 60.42,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 548.34,
    y: 59.54,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 548.34,
    y: 58.65,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 548.34,
    y: 57.76,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 548.34,
    y: 56.87,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 548.34,
    y: 55.98,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 548.34,
    y: 55.1,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 548.34,
    y: 54.21,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 548.34,
    y: 53.32,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 548.34,
    y: 52.43,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 548.34,
    y: 51.54,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 548.34,
    y: 50.65,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 548.34,
    y: 49.77,
    width: 61.74,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 548.34,
    y: 49.37,
    width: 61.74,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 641.3,
    y: 100.39,
    width: 16.15,
    height: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 641.3,
    y: 99.5,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 641.3,
    y: 98.61,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 641.3,
    y: 97.72,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 641.3,
    y: 96.83,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 641.3,
    y: 95.95,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 641.3,
    y: 95.06,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 641.3,
    y: 94.17,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 641.3,
    y: 93.28,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 641.3,
    y: 92.39,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 641.3,
    y: 91.51,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 641.3,
    y: 90.62,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 641.3,
    y: 89.73,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 641.3,
    y: 88.84,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 641.3,
    y: 87.95,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 641.3,
    y: 87.06,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 641.3,
    y: 86.18,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 641.3,
    y: 85.29,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 641.3,
    y: 84.4,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 641.3,
    y: 83.51,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 641.3,
    y: 82.62,
    width: 16.15,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 641.3,
    y: 81.96,
    width: 16.15,
    height: 0.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 619.54,
    y: 144.79,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 619.54,
    y: 143.9,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 619.54,
    y: 143.01,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 619.54,
    y: 142.12,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 619.54,
    y: 141.24,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 619.54,
    y: 140.35,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 619.54,
    y: 139.46,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 619.54,
    y: 138.57,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 619.54,
    y: 137.68,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 619.54,
    y: 136.8,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 619.54,
    y: 135.91,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 619.54,
    y: 135.02,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 619.54,
    y: 134.13,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 619.54,
    y: 133.24,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 619.54,
    y: 132.36,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 619.54,
    y: 131.47,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 619.54,
    y: 130.58,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 619.54,
    y: 129.69,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 619.54,
    y: 128.8,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 619.54,
    y: 127.92,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 619.54,
    y: 127.03,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 619.54,
    y: 126.14,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 619.54,
    y: 125.25,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 619.54,
    y: 124.36,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 619.54,
    y: 123.47,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 619.54,
    y: 122.59,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 619.54,
    y: 121.7,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 619.54,
    y: 120.81,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 619.54,
    y: 119.92,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 619.54,
    y: 119.03,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 619.54,
    y: 118.15,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 619.54,
    y: 117.26,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 619.54,
    y: 116.37,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 619.54,
    y: 115.48,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 619.54,
    y: 114.59,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 619.54,
    y: 113.71,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 619.54,
    y: 112.82,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 619.54,
    y: 111.93,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 619.54,
    y: 111.04,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 619.54,
    y: 110.15,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 619.54,
    y: 109.27,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 619.54,
    y: 108.38,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 619.54,
    y: 107.49,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 619.54,
    y: 106.6,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 619.54,
    y: 105.71,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 619.54,
    y: 104.83,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 619.54,
    y: 103.94,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 619.54,
    y: 103.05,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 619.54,
    y: 102.16,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 619.54,
    y: 101.27,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 619.54,
    y: 100.39,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 619.54,
    y: 99.5,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 619.54,
    y: 98.61,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 619.54,
    y: 97.72,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 619.54,
    y: 96.83,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 619.54,
    y: 95.95,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 619.54,
    y: 95.06,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 619.54,
    y: 94.17,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 619.54,
    y: 93.28,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 619.54,
    y: 92.39,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 619.54,
    y: 91.51,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 619.54,
    y: 90.62,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 619.54,
    y: 89.73,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 619.54,
    y: 88.84,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 619.54,
    y: 87.95,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 619.54,
    y: 87.06,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 619.54,
    y: 86.18,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 619.54,
    y: 85.29,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 619.54,
    y: 84.4,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 619.54,
    y: 83.51,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 619.54,
    y: 82.62,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 619.54,
    y: 81.74,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 619.54,
    y: 80.85,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 619.54,
    y: 79.96,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 619.54,
    y: 79.07,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 619.54,
    y: 78.18,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 619.54,
    y: 77.3,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 619.54,
    y: 76.41,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 619.54,
    y: 75.52,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 619.54,
    y: 74.63,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 619.54,
    y: 73.74,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 619.54,
    y: 72.86,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 619.54,
    y: 71.97,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 619.54,
    y: 71.08,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 619.54,
    y: 70.19,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 619.54,
    y: 69.3,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 619.54,
    y: 68.42,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 619.54,
    y: 67.53,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 619.54,
    y: 66.64,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 619.54,
    y: 65.75,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 619.54,
    y: 64.86,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 619.54,
    y: 63.98,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 619.54,
    y: 63.09,
    width: 60.07,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 619.54,
    y: 62.86,
    width: 60.07,
    height: 0.23
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 686.5,
    y: 119.03,
    width: 42.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 686.5,
    y: 118.15,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 686.5,
    y: 117.26,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 686.5,
    y: 116.37,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 686.5,
    y: 115.48,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 686.5,
    y: 114.59,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 686.5,
    y: 113.71,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 686.5,
    y: 112.82,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 686.5,
    y: 111.93,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 686.5,
    y: 111.04,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 686.5,
    y: 110.15,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 686.5,
    y: 109.27,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 686.5,
    y: 108.38,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 686.5,
    y: 107.49,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 686.5,
    y: 106.6,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 686.5,
    y: 105.71,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 686.5,
    y: 104.83,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 686.5,
    y: 103.94,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 686.5,
    y: 103.05,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 686.5,
    y: 102.16,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 686.5,
    y: 101.27,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 686.5,
    y: 100.39,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 686.5,
    y: 99.5,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 686.5,
    y: 98.61,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 686.5,
    y: 97.72,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 686.5,
    y: 96.83,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 686.5,
    y: 95.95,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 686.5,
    y: 95.06,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 686.5,
    y: 94.17,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 686.5,
    y: 93.28,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 686.5,
    y: 92.39,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 686.5,
    y: 91.51,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 686.5,
    y: 90.62,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 686.5,
    y: 89.73,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 686.5,
    y: 88.84,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 686.5,
    y: 87.95,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 686.5,
    y: 87.06,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 686.5,
    y: 86.18,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 686.5,
    y: 85.29,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 686.5,
    y: 84.4,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 686.5,
    y: 83.51,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 686.5,
    y: 82.62,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 686.5,
    y: 81.74,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 686.5,
    y: 80.85,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 686.5,
    y: 79.96,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 686.5,
    y: 79.07,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 686.5,
    y: 78.18,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 686.5,
    y: 77.3,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 686.5,
    y: 76.41,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 686.5,
    y: 75.52,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 686.5,
    y: 74.63,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 686.5,
    y: 73.74,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 686.5,
    y: 72.86,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 686.5,
    y: 71.97,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 686.5,
    y: 71.08,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 686.5,
    y: 70.19,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 686.5,
    y: 69.3,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 686.5,
    y: 68.42,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 686.5,
    y: 67.53,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 686.5,
    y: 66.64,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 686.5,
    y: 65.75,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 686.5,
    y: 64.86,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 686.5,
    y: 63.98,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 686.5,
    y: 63.09,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 686.5,
    y: 62.2,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 686.5,
    y: 61.31,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 686.5,
    y: 60.42,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 686.5,
    y: 59.54,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 686.5,
    y: 58.65,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 686.5,
    y: 57.76,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 686.5,
    y: 56.87,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 686.5,
    y: 55.98,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 686.5,
    y: 55.1,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 686.5,
    y: 54.21,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 686.5,
    y: 53.32,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 686.5,
    y: 52.43,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 686.5,
    y: 51.54,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 686.5,
    y: 50.65,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 686.5,
    y: 49.77,
    width: 42.94,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 686.5,
    y: 49.37,
    width: 42.94,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 755.53,
    y: 100.39,
    width: 14.38,
    height: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 755.53,
    y: 99.5,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 755.53,
    y: 98.61,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 755.53,
    y: 97.72,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 755.53,
    y: 96.83,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 755.53,
    y: 95.95,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 755.53,
    y: 95.06,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 755.53,
    y: 94.17,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 755.53,
    y: 93.28,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 755.53,
    y: 92.39,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 755.53,
    y: 91.51,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 755.53,
    y: 90.62,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 755.53,
    y: 89.73,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 755.53,
    y: 88.84,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 755.53,
    y: 87.95,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 755.53,
    y: 87.06,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 755.53,
    y: 86.18,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 755.53,
    y: 85.29,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 755.53,
    y: 84.4,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 755.53,
    y: 83.51,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 755.53,
    y: 82.62,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 755.53,
    y: 81.76,
    width: 14.38,
    height: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 733.37,
    y: 119.03,
    width: 58.69,
    height: 0.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 733.37,
    y: 118.15,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 733.37,
    y: 117.26,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 733.37,
    y: 116.37,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 733.37,
    y: 115.48,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 733.37,
    y: 114.59,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 733.37,
    y: 113.71,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 733.37,
    y: 112.82,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 733.37,
    y: 111.93,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 733.37,
    y: 111.04,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 733.37,
    y: 110.15,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 733.37,
    y: 109.27,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 733.37,
    y: 108.38,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 733.37,
    y: 107.49,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 733.37,
    y: 106.6,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 733.37,
    y: 105.71,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 733.37,
    y: 104.83,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 733.37,
    y: 103.94,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 733.37,
    y: 103.05,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 733.37,
    y: 102.16,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 733.37,
    y: 101.27,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 733.37,
    y: 100.39,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 733.37,
    y: 99.5,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 733.37,
    y: 98.61,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 733.37,
    y: 97.72,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 733.37,
    y: 96.83,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 733.37,
    y: 95.95,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 733.37,
    y: 95.06,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 733.37,
    y: 94.17,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 733.37,
    y: 93.28,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 733.37,
    y: 92.39,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 733.37,
    y: 91.51,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 733.37,
    y: 90.62,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 733.37,
    y: 89.73,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 733.37,
    y: 88.84,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 733.37,
    y: 87.95,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 733.37,
    y: 87.06,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 733.37,
    y: 86.18,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 733.37,
    y: 85.29,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 733.37,
    y: 84.4,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 733.37,
    y: 83.51,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 733.37,
    y: 82.62,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 733.37,
    y: 81.74,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 733.37,
    y: 80.85,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 733.37,
    y: 79.96,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 733.37,
    y: 79.07,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 733.37,
    y: 78.18,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 733.37,
    y: 77.3,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 733.37,
    y: 76.41,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 733.37,
    y: 75.52,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 733.37,
    y: 74.63,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 733.37,
    y: 73.74,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 733.37,
    y: 72.86,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 733.37,
    y: 71.97,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 733.37,
    y: 71.08,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 733.37,
    y: 70.19,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 733.37,
    y: 69.3,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 733.37,
    y: 68.42,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 733.37,
    y: 67.53,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 733.37,
    y: 66.64,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 733.37,
    y: 65.75,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 733.37,
    y: 64.86,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 733.37,
    y: 63.98,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 733.37,
    y: 63.09,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 733.37,
    y: 62.86,
    width: 58.69,
    height: 0.23
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 818.16,
    y: 100.39,
    width: 14.38,
    height: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 818.16,
    y: 99.5,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 818.16,
    y: 98.61,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 818.16,
    y: 97.72,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 818.16,
    y: 96.83,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 818.16,
    y: 95.95,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 818.16,
    y: 95.06,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 818.16,
    y: 94.17,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 818.16,
    y: 93.28,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 818.16,
    y: 92.39,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 818.16,
    y: 91.51,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 818.16,
    y: 90.62,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 818.16,
    y: 89.73,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 818.16,
    y: 88.84,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 818.16,
    y: 87.95,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 818.16,
    y: 87.06,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 818.16,
    y: 86.18,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 818.16,
    y: 85.29,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 818.16,
    y: 84.4,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 818.16,
    y: 83.51,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 818.16,
    y: 82.62,
    width: 14.38,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 818.16,
    y: 81.76,
    width: 14.38,
    height: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 796,
    y: 119.03,
    width: 58.69,
    height: 0.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 796,
    y: 118.15,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 796,
    y: 117.26,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 796,
    y: 116.37,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 796,
    y: 115.48,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 796,
    y: 114.59,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 796,
    y: 113.71,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 796,
    y: 112.82,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 796,
    y: 111.93,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 796,
    y: 111.04,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 796,
    y: 110.15,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 796,
    y: 109.27,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 796,
    y: 108.38,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 796,
    y: 107.49,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 796,
    y: 106.6,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 796,
    y: 105.71,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 796,
    y: 104.83,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 796,
    y: 103.94,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 796,
    y: 103.05,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 796,
    y: 102.16,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 796,
    y: 101.27,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 796,
    y: 100.39,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 796,
    y: 99.5,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 796,
    y: 98.61,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 796,
    y: 97.72,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 796,
    y: 96.83,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 796,
    y: 95.95,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 796,
    y: 95.06,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 796,
    y: 94.17,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 796,
    y: 93.28,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 796,
    y: 92.39,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 796,
    y: 91.51,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 796,
    y: 90.62,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 796,
    y: 89.73,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 796,
    y: 88.84,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 796,
    y: 87.95,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 796,
    y: 87.06,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 796,
    y: 86.18,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 796,
    y: 85.29,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 796,
    y: 84.4,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 796,
    y: 83.51,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 796,
    y: 82.62,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 796,
    y: 81.74,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 796,
    y: 80.85,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 796,
    y: 79.96,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 796,
    y: 79.07,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 796,
    y: 78.18,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 796,
    y: 77.3,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 796,
    y: 76.41,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 796,
    y: 75.52,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 796,
    y: 74.63,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 796,
    y: 73.74,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 796,
    y: 72.86,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 796,
    y: 71.97,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 796,
    y: 71.08,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 796,
    y: 70.19,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 796,
    y: 69.3,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 796,
    y: 68.42,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 796,
    y: 67.53,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 796,
    y: 66.64,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 796,
    y: 65.75,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 796,
    y: 64.86,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 796,
    y: 63.98,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 796,
    y: 63.09,
    width: 58.69,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 796,
    y: 62.86,
    width: 58.69,
    height: 0.23
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-204"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 858.14,
    y: 119.03,
    width: 38.01,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 858.14,
    y: 118.15,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 858.14,
    y: 117.26,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 858.14,
    y: 116.37,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 858.14,
    y: 115.48,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 858.14,
    y: 114.59,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 858.14,
    y: 113.71,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 858.14,
    y: 112.82,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 858.14,
    y: 111.93,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 858.14,
    y: 111.04,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 858.14,
    y: 110.15,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 858.14,
    y: 109.27,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 858.14,
    y: 108.38,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 858.14,
    y: 107.49,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 858.14,
    y: 106.6,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 858.14,
    y: 105.71,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 858.14,
    y: 104.83,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 858.14,
    y: 103.94,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 858.14,
    y: 103.05,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 858.14,
    y: 102.16,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 858.14,
    y: 101.27,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 858.14,
    y: 100.39,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 858.14,
    y: 99.5,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 858.14,
    y: 98.61,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 858.14,
    y: 97.72,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 858.14,
    y: 96.83,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 858.14,
    y: 95.95,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 858.14,
    y: 95.06,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 858.14,
    y: 94.17,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 858.14,
    y: 93.28,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 858.14,
    y: 92.39,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 858.14,
    y: 91.51,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 858.14,
    y: 90.62,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 858.14,
    y: 89.73,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 858.14,
    y: 88.84,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 858.14,
    y: 87.95,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 858.14,
    y: 87.06,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 858.14,
    y: 86.18,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 858.14,
    y: 85.29,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 858.14,
    y: 84.4,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 858.14,
    y: 83.51,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 858.14,
    y: 82.62,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 858.14,
    y: 81.74,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 858.14,
    y: 80.85,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 858.14,
    y: 79.96,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 858.14,
    y: 79.07,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 858.14,
    y: 78.18,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 858.14,
    y: 77.3,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 858.14,
    y: 76.41,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 858.14,
    y: 75.52,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 858.14,
    y: 74.63,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 858.14,
    y: 73.74,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 858.14,
    y: 72.86,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 858.14,
    y: 71.97,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 858.14,
    y: 71.08,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 858.14,
    y: 70.19,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 858.14,
    y: 69.3,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 858.14,
    y: 68.42,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 858.14,
    y: 67.53,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 858.14,
    y: 66.64,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 858.14,
    y: 65.75,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 858.14,
    y: 64.86,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 858.14,
    y: 63.98,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 858.14,
    y: 63.09,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 858.14,
    y: 62.2,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 858.14,
    y: 61.31,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 858.14,
    y: 60.42,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 858.14,
    y: 59.54,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 858.14,
    y: 58.65,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 858.14,
    y: 57.76,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 858.14,
    y: 56.87,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 858.14,
    y: 55.98,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 858.14,
    y: 55.1,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 858.14,
    y: 54.21,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 858.14,
    y: 53.32,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 858.14,
    y: 52.43,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 858.14,
    y: 51.54,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 858.14,
    y: 50.65,
    width: 38.01,
    height: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 858.14,
    y: 50.15,
    width: 38.01,
    height: 0.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M377.48,139.71c-2.87-2.87-7.52-2.87-10.39,0l-7.2,7.2-7.2-7.2c-2.87-2.87-7.52-2.87-10.39,0-2.87,2.87-2.87,7.52,0,10.39l7.2,7.2-7.2,7.2c-2.87,2.87-2.87,7.52,0,10.39,2.87,2.87,7.52,2.87,10.39,0l7.2-7.2,7.2,7.2c2.87,2.87,7.52,2.87,10.39,0,2.87-2.87,2.87-7.52,0-10.39l-7.2-7.2,7.2-7.2c2.87-2.87,2.87-7.52,0-10.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M806.45,19.75l7.2-7.2c2.87-2.87,2.87-7.52,0-10.39-2.87-2.87-7.52-2.87-10.39,0l-7.2,7.2-7.2-7.2c-2.87-2.87-7.52-2.87-10.39,0-2.87,2.87-2.87,7.52,0,10.39l7.2,7.2-7.2,7.2c-2.87,2.87-2.87,7.52,0,10.39,2.87,2.87,7.52,2.87,10.39,0l7.2-7.2,7.2,7.2c2.87,2.87,7.52,2.87,10.39,0,2.87-2.87,2.87-7.52,0-10.39l-7.2-7.2Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M249.36,115.55l-29.46-83.61c-3.34-9.49-12.31-15.84-22.38-15.84H53.76c-10.06,0-19.03,6.35-22.38,15.84L1.92,115.55c-7.63,21.67,8.44,44.38,31.42,44.38h0c10.28,0,19.98-4.75,26.29-12.86l36.95-47.5h58.13l36.95,47.5c6.31,8.11,16.01,12.86,26.29,12.86h0c22.97,0,39.05-22.71,31.42-44.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M219.9,31.94c-3.34-9.49-12.31-15.84-22.38-15.84H53.76c-10.06,0-19.03,6.35-22.38,15.84-1.21,3.44-.96,7.22,.69,10.47,16.29,32,48.5,54.53,86.21,57.15h14.73c37.7-2.62,69.92-25.15,86.21-57.15,1.65-3.25,1.9-7.03,.69-10.47Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: -5.71,
    y: 16.1,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: -5.71,
    y: 17.38,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: -5.71,
    y: 18.67,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: -5.71,
    y: 19.95,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: -5.71,
    y: 21.23,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: -5.71,
    y: 22.52,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -5.71,
    y: 23.8,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: -5.71,
    y: 25.09,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: -5.71,
    y: 26.37,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: -5.71,
    y: 27.66,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: -5.71,
    y: 28.94,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: -5.71,
    y: 30.22,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: -5.71,
    y: 31.51,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: -5.71,
    y: 32.79,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: -5.71,
    y: 34.08,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: -5.71,
    y: 35.36,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: -5.71,
    y: 36.64,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: -5.71,
    y: 37.93,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: -5.71,
    y: 39.21,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: -5.71,
    y: 40.5,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: -5.71,
    y: 41.78,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: -5.71,
    y: 43.07,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: -5.71,
    y: 44.35,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: -5.71,
    y: 45.63,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: -5.71,
    y: 46.92,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: -5.71,
    y: 48.2,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: -5.71,
    y: 49.49,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: -5.71,
    y: 50.77,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: -5.71,
    y: 52.05,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: -5.71,
    y: 53.34,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: -5.71,
    y: 54.62,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: -5.71,
    y: 55.91,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: -5.71,
    y: 57.19,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: -5.71,
    y: 58.48,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: -5.71,
    y: 59.76,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: -5.71,
    y: 61.04,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: -5.71,
    y: 62.33,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: -5.71,
    y: 63.61,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: -5.71,
    y: 64.9,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: -5.71,
    y: 66.18,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: -5.71,
    y: 67.46,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: -5.71,
    y: 68.75,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: -5.71,
    y: 70.03,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: -5.71,
    y: 71.32,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: -5.71,
    y: 72.6,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: -5.71,
    y: 73.89,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: -5.71,
    y: 75.17,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: -5.71,
    y: 76.45,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: -5.71,
    y: 77.74,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: -5.71,
    y: 79.02,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: -5.71,
    y: 80.31,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: -5.71,
    y: 81.59,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: -5.71,
    y: 82.87,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: -5.71,
    y: 84.16,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: -5.71,
    y: 85.44,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: -5.71,
    y: 86.73,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: -5.71,
    y: 88.01,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: -5.71,
    y: 89.3,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: -5.71,
    y: 90.58,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: -5.71,
    y: 91.86,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: -5.71,
    y: 93.15,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: -5.71,
    y: 94.43,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -5.71,
    y: 95.72,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: -5.71,
    y: 97,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: -5.71,
    y: 98.28,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: -5.71,
    y: 99.57,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: -5.71,
    y: 100.85,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: -5.71,
    y: 102.14,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: -5.71,
    y: 103.42,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: -5.71,
    y: 104.71,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: -5.71,
    y: 105.99,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: -5.71,
    y: 107.27,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: -5.71,
    y: 108.56,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: -5.71,
    y: 109.84,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: -5.71,
    y: 111.13,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: -5.71,
    y: 112.41,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -5.71,
    y: 113.69,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: -5.71,
    y: 114.98,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: -5.71,
    y: 116.26,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: -5.71,
    y: 117.55,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: -5.71,
    y: 118.83,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: -5.71,
    y: 120.12,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: -5.71,
    y: 121.4,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: -5.71,
    y: 122.68,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: -5.71,
    y: 123.97,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: -5.71,
    y: 125.25,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: -5.71,
    y: 126.54,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: -5.71,
    y: 127.82,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: -5.71,
    y: 129.1,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: -5.71,
    y: 130.39,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: -5.71,
    y: 131.67,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: -5.71,
    y: 132.96,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: -5.71,
    y: 134.24,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: -5.71,
    y: 135.53,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: -5.71,
    y: 136.81,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: -5.71,
    y: 138.09,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: -5.71,
    y: 139.38,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: -5.71,
    y: 140.66,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: -5.71,
    y: 141.95,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: -5.71,
    y: 143.23,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: -5.71,
    y: 144.51,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: -5.71,
    y: 145.8,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: -5.71,
    y: 147.08,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: -5.71,
    y: 148.37,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: -5.71,
    y: 149.65,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: -5.71,
    y: 150.94,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: -5.71,
    y: 152.22,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: -5.71,
    y: 153.5,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: -5.71,
    y: 154.79,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: -5.71,
    y: 156.07,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: -5.71,
    y: 157.36,
    width: 262.71,
    height: 1.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -5.71,
    y: 158.64,
    width: 262.71,
    height: 1.28
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: -1.98,
    y: 147.78,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: -1.98,
    y: 146.59,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: -1.98,
    y: 145.41,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: -1.98,
    y: 144.22,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: -1.98,
    y: 143.04,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: -1.98,
    y: 141.85,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -1.98,
    y: 140.66,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: -1.98,
    y: 139.48,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: -1.98,
    y: 138.29,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: -1.98,
    y: 137.1,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: -1.98,
    y: 135.92,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: -1.98,
    y: 134.73,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: -1.98,
    y: 133.55,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: -1.98,
    y: 132.36,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: -1.98,
    y: 131.17,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: -1.98,
    y: 129.99,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: -1.98,
    y: 128.8,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: -1.98,
    y: 127.61,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: -1.98,
    y: 126.43,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: -1.98,
    y: 125.24,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: -1.98,
    y: 124.05,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: -1.98,
    y: 122.87,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: -1.98,
    y: 121.68,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: -1.98,
    y: 120.5,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: -1.98,
    y: 119.31,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: -1.98,
    y: 118.12,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: -1.98,
    y: 116.94,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: -1.98,
    y: 115.75,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: -1.98,
    y: 114.56,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: -1.98,
    y: 113.38,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: -1.98,
    y: 112.19,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: -1.98,
    y: 111,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: -1.98,
    y: 109.82,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: -1.98,
    y: 108.63,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: -1.98,
    y: 107.45,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: -1.98,
    y: 106.26,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: -1.98,
    y: 105.07,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: -1.98,
    y: 103.89,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: -1.98,
    y: 102.7,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: -1.98,
    y: 101.51,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: -1.98,
    y: 100.33,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: -1.98,
    y: 99.14,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: -1.98,
    y: 97.95,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: -1.98,
    y: 96.77,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: -1.98,
    y: 95.58,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: -1.98,
    y: 94.4,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: -1.98,
    y: 93.21,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: -1.98,
    y: 92.02,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: -1.98,
    y: 90.84,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: -1.98,
    y: 89.65,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: -1.98,
    y: 88.46,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: -1.98,
    y: 87.28,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: -1.98,
    y: 86.09,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: -1.98,
    y: 84.91,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: -1.98,
    y: 83.72,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: -1.98,
    y: 82.53,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: -1.98,
    y: 81.35,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: -1.98,
    y: 80.16,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: -1.98,
    y: 78.97,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: -1.98,
    y: 77.79,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: -1.98,
    y: 76.6,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: -1.98,
    y: 75.41,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: -1.98,
    y: 74.23,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: -1.98,
    y: 73.04,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: -1.98,
    y: 71.86,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: -1.98,
    y: 70.67,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: -1.98,
    y: 69.48,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: -1.98,
    y: 68.3,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: -1.98,
    y: 67.11,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: -1.98,
    y: 65.92,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: -1.98,
    y: 64.74,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: -1.98,
    y: 63.55,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: -1.98,
    y: 62.36,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: -1.98,
    y: 61.18,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: -1.98,
    y: 59.99,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: -1.98,
    y: 58.81,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -1.98,
    y: 57.62,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: -1.98,
    y: 56.43,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: -1.98,
    y: 55.25,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: -1.98,
    y: 54.06,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: -1.98,
    y: 52.87,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: -1.98,
    y: 51.69,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: -1.98,
    y: 50.5,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: -1.98,
    y: 49.32,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: -1.98,
    y: 48.13,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: -1.98,
    y: 46.94,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: -1.98,
    y: 45.76,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: -1.98,
    y: 44.57,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: -1.98,
    y: 43.38,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: -1.98,
    y: 42.2,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: -1.98,
    y: 41.01,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: -1.98,
    y: 39.82,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: -1.98,
    y: 38.64,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: -1.98,
    y: 37.45,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: -1.98,
    y: 36.27,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: -1.98,
    y: 35.08,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: -1.98,
    y: 33.89,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: -1.98,
    y: 32.71,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: -1.98,
    y: 31.52,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: -1.98,
    y: 30.33,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: -1.98,
    y: 29.15,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: -1.98,
    y: 27.96,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: -1.98,
    y: 26.77,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: -1.98,
    y: 25.59,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: -1.98,
    y: 24.4,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: -1.98,
    y: 23.22,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: -1.98,
    y: 22.03,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: -1.98,
    y: 20.84,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: -1.98,
    y: 19.66,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: -1.98,
    y: 18.47,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: -1.98,
    y: 17.28,
    width: 255.65,
    height: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1.98,
    y: 16.1,
    width: 255.65,
    height: 1.19
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-178",
    cx: 70.28,
    cy: 51.85,
    r: 45.29,
    transform: "translate(-4.52 96.94) rotate(-67.5)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-178",
    cx: 181,
    cy: 51.85,
    r: 45.29,
    transform: "translate(95.86 219.78) rotate(-79.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 27.88,
    y: 93.25,
    width: 84.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 27.88,
    y: 92.12,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 27.88,
    y: 90.99,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 27.88,
    y: 89.86,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 27.88,
    y: 88.73,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 27.88,
    y: 87.6,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 27.88,
    y: 86.47,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 27.88,
    y: 85.34,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 27.88,
    y: 84.21,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 27.88,
    y: 83.08,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 27.88,
    y: 81.95,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 27.88,
    y: 80.81,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 27.88,
    y: 79.68,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 27.88,
    y: 78.55,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 27.88,
    y: 77.42,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 27.88,
    y: 76.29,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 27.88,
    y: 75.16,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 27.88,
    y: 74.03,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 27.88,
    y: 72.9,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 27.88,
    y: 71.77,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 27.88,
    y: 70.64,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 27.88,
    y: 69.51,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 27.88,
    y: 68.38,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 27.88,
    y: 67.25,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 27.88,
    y: 66.12,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 27.88,
    y: 64.99,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 27.88,
    y: 63.86,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 27.88,
    y: 62.72,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 27.88,
    y: 61.59,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 27.88,
    y: 60.46,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 27.88,
    y: 59.33,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 27.88,
    y: 58.2,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 27.88,
    y: 57.07,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 27.88,
    y: 55.94,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 27.88,
    y: 54.81,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 27.88,
    y: 53.68,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 27.88,
    y: 52.55,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 27.88,
    y: 51.42,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 27.88,
    y: 50.29,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 27.88,
    y: 49.16,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 27.88,
    y: 48.03,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 27.88,
    y: 46.9,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 27.88,
    y: 45.77,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 27.88,
    y: 44.63,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 27.88,
    y: 43.5,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 27.88,
    y: 42.37,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 27.88,
    y: 41.24,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 27.88,
    y: 40.11,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 27.88,
    y: 38.98,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 27.88,
    y: 37.85,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 27.88,
    y: 36.72,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 27.88,
    y: 35.59,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 27.88,
    y: 34.46,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 27.88,
    y: 33.33,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 27.88,
    y: 32.2,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 27.88,
    y: 31.07,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 27.88,
    y: 29.94,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 27.88,
    y: 28.81,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 27.88,
    y: 27.68,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 27.88,
    y: 26.54,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 27.88,
    y: 25.41,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 27.88,
    y: 24.28,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 27.88,
    y: 23.15,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 27.88,
    y: 22.02,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 27.88,
    y: 20.89,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 27.88,
    y: 19.76,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 27.88,
    y: 18.63,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 27.88,
    y: 17.5,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 27.88,
    y: 16.37,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 27.88,
    y: 15.24,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 27.88,
    y: 14.11,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 27.88,
    y: 12.98,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 27.88,
    y: 11.85,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 27.88,
    y: 10.72,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 27.88,
    y: 9.59,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 27.88,
    y: 9.45,
    width: 84.8,
    height: 0.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 22.1,
    y: 98.9,
    width: 96.35,
    height: 1.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 22.1,
    y: 97.77,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 22.1,
    y: 96.64,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 22.1,
    y: 95.51,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 22.1,
    y: 94.38,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 22.1,
    y: 93.25,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 22.1,
    y: 92.12,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 22.1,
    y: 90.99,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 22.1,
    y: 89.86,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 22.1,
    y: 88.73,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 22.1,
    y: 87.6,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 22.1,
    y: 86.47,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 22.1,
    y: 85.34,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 22.1,
    y: 84.21,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 22.1,
    y: 83.08,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 22.1,
    y: 81.95,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 22.1,
    y: 80.81,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 22.1,
    y: 79.68,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 22.1,
    y: 78.55,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 22.1,
    y: 77.42,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 22.1,
    y: 76.29,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 22.1,
    y: 75.16,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 22.1,
    y: 74.03,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 22.1,
    y: 72.9,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 22.1,
    y: 71.77,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 22.1,
    y: 70.64,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 22.1,
    y: 69.51,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 22.1,
    y: 68.38,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 22.1,
    y: 67.25,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 22.1,
    y: 66.12,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 22.1,
    y: 64.99,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 22.1,
    y: 63.86,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 22.1,
    y: 62.72,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 22.1,
    y: 61.59,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 22.1,
    y: 60.46,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 22.1,
    y: 59.33,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 22.1,
    y: 58.2,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 22.1,
    y: 57.07,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 22.1,
    y: 55.94,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 22.1,
    y: 54.81,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 22.1,
    y: 53.68,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 22.1,
    y: 52.55,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 22.1,
    y: 51.42,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 22.1,
    y: 50.29,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 22.1,
    y: 49.16,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 22.1,
    y: 48.03,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 22.1,
    y: 46.9,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 22.1,
    y: 45.77,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 22.1,
    y: 44.63,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 22.1,
    y: 43.5,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 22.1,
    y: 42.37,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.1,
    y: 41.24,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 22.1,
    y: 40.11,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 22.1,
    y: 38.98,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 22.1,
    y: 37.85,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 22.1,
    y: 36.72,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 22.1,
    y: 35.59,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 22.1,
    y: 34.46,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 22.1,
    y: 33.33,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 22.1,
    y: 32.2,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 22.1,
    y: 31.07,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 22.1,
    y: 29.94,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 22.1,
    y: 28.81,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 22.1,
    y: 27.68,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 22.1,
    y: 26.54,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 22.1,
    y: 25.41,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 22.1,
    y: 24.28,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 22.1,
    y: 23.15,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 22.1,
    y: 22.02,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 22.1,
    y: 20.89,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 22.1,
    y: 19.76,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 22.1,
    y: 18.63,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 22.1,
    y: 17.5,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 22.1,
    y: 16.37,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 22.1,
    y: 15.24,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 22.1,
    y: 14.11,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 22.1,
    y: 12.98,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 22.1,
    y: 11.85,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 22.1,
    y: 10.72,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 22.1,
    y: 9.59,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 22.1,
    y: 8.45,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 22.1,
    y: 7.32,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 22.1,
    y: 3.67,
    width: 96.35,
    height: 3.65
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-188"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 138.6,
    y: 93.25,
    width: 84.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 138.6,
    y: 92.12,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 138.6,
    y: 90.99,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 138.6,
    y: 89.86,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 138.6,
    y: 88.73,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 138.6,
    y: 87.6,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 138.6,
    y: 86.47,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 138.6,
    y: 85.34,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 138.6,
    y: 84.21,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 138.6,
    y: 83.08,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 138.6,
    y: 81.95,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 138.6,
    y: 80.81,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 138.6,
    y: 79.68,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 138.6,
    y: 78.55,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 138.6,
    y: 77.42,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 138.6,
    y: 76.29,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 138.6,
    y: 75.16,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 138.6,
    y: 74.03,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 138.6,
    y: 72.9,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 138.6,
    y: 71.77,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 138.6,
    y: 70.64,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 138.6,
    y: 69.51,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 138.6,
    y: 68.38,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 138.6,
    y: 67.25,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 138.6,
    y: 66.12,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 138.6,
    y: 64.99,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 138.6,
    y: 63.86,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 138.6,
    y: 62.72,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 138.6,
    y: 61.59,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 138.6,
    y: 60.46,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 138.6,
    y: 59.33,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 138.6,
    y: 58.2,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 138.6,
    y: 57.07,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 138.6,
    y: 55.94,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 138.6,
    y: 54.81,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 138.6,
    y: 53.68,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 138.6,
    y: 52.55,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 138.6,
    y: 51.42,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 138.6,
    y: 50.29,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 138.6,
    y: 49.16,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 138.6,
    y: 48.03,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 138.6,
    y: 46.9,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 138.6,
    y: 45.77,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 138.6,
    y: 44.63,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 138.6,
    y: 43.5,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 138.6,
    y: 42.37,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 138.6,
    y: 41.24,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 138.6,
    y: 40.11,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 138.6,
    y: 38.98,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 138.6,
    y: 37.85,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 138.6,
    y: 36.72,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 138.6,
    y: 35.59,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 138.6,
    y: 34.46,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 138.6,
    y: 33.33,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 138.6,
    y: 32.2,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 138.6,
    y: 31.07,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 138.6,
    y: 29.94,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 138.6,
    y: 28.81,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 138.6,
    y: 27.68,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 138.6,
    y: 26.54,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 138.6,
    y: 25.41,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 138.6,
    y: 24.28,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 138.6,
    y: 23.15,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 138.6,
    y: 22.02,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 138.6,
    y: 20.89,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 138.6,
    y: 19.76,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 138.6,
    y: 18.63,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 138.6,
    y: 17.5,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 138.6,
    y: 16.37,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 138.6,
    y: 15.24,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 138.6,
    y: 14.11,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 138.6,
    y: 12.98,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 138.6,
    y: 11.85,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 138.6,
    y: 10.72,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 138.6,
    y: 9.59,
    width: 84.8,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 138.6,
    y: 9.45,
    width: 84.8,
    height: 0.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 132.82,
    y: 98.9,
    width: 96.35,
    height: 1.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 132.82,
    y: 97.77,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 132.82,
    y: 96.64,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 132.82,
    y: 95.51,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 132.82,
    y: 94.38,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 132.82,
    y: 93.25,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 132.82,
    y: 92.12,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 132.82,
    y: 90.99,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 132.82,
    y: 89.86,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 132.82,
    y: 88.73,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 132.82,
    y: 87.6,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 132.82,
    y: 86.47,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 132.82,
    y: 85.34,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 132.82,
    y: 84.21,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 132.82,
    y: 83.08,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 132.82,
    y: 81.95,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 132.82,
    y: 80.81,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 132.82,
    y: 79.68,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 132.82,
    y: 78.55,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 132.82,
    y: 77.42,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 132.82,
    y: 76.29,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 132.82,
    y: 75.16,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 132.82,
    y: 74.03,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 132.82,
    y: 72.9,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 132.82,
    y: 71.77,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 132.82,
    y: 70.64,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 132.82,
    y: 69.51,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 132.82,
    y: 68.38,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 132.82,
    y: 67.25,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 132.82,
    y: 66.12,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 132.82,
    y: 64.99,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 132.82,
    y: 63.86,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 132.82,
    y: 62.72,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 132.82,
    y: 61.59,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 132.82,
    y: 60.46,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 132.82,
    y: 59.33,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 132.82,
    y: 58.2,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 132.82,
    y: 57.07,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 132.82,
    y: 55.94,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 132.82,
    y: 54.81,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 132.82,
    y: 53.68,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 132.82,
    y: 52.55,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 132.82,
    y: 51.42,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 132.82,
    y: 50.29,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 132.82,
    y: 49.16,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 132.82,
    y: 48.03,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 132.82,
    y: 46.9,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 132.82,
    y: 45.77,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 132.82,
    y: 44.63,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 132.82,
    y: 43.5,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 132.82,
    y: 42.37,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 132.82,
    y: 41.24,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 132.82,
    y: 40.11,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 132.82,
    y: 38.98,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 132.82,
    y: 37.85,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 132.82,
    y: 36.72,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 132.82,
    y: 35.59,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 132.82,
    y: 34.46,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 132.82,
    y: 33.33,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 132.82,
    y: 32.2,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 132.82,
    y: 31.07,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 132.82,
    y: 29.94,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 132.82,
    y: 28.81,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 132.82,
    y: 27.68,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 132.82,
    y: 26.54,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 132.82,
    y: 25.41,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 132.82,
    y: 24.28,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 132.82,
    y: 23.15,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 132.82,
    y: 22.02,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 132.82,
    y: 20.89,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 132.82,
    y: 19.76,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 132.82,
    y: 18.63,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 132.82,
    y: 17.5,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 132.82,
    y: 16.37,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 132.82,
    y: 15.24,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 132.82,
    y: 14.11,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 132.82,
    y: 12.98,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 132.82,
    y: 11.85,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 132.82,
    y: 10.72,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 132.82,
    y: 9.59,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 132.82,
    y: 8.45,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 132.82,
    y: 7.32,
    width: 96.35,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 132.82,
    y: 3.67,
    width: 96.35,
    height: 3.65
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M88.77,44.1h-10.75v-10.75c0-4.28-3.47-7.75-7.75-7.75s-7.75,3.47-7.75,7.75v10.75h-10.75c-4.28,0-7.75,3.47-7.75,7.75s3.47,7.75,7.75,7.75h10.75v10.75c0,4.28,3.47,7.75,7.75,7.75s7.75-3.47,7.75-7.75v-10.75h10.75c4.28,0,7.75-3.47,7.75-7.75s-3.47-7.75-7.75-7.75Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-134",
    cx: 181,
    cy: 32.65,
    r: 9.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-134",
    cx: 181,
    cy: 71.05,
    r: 9.07,
    transform: "translate(2.77 148.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-80",
    cx: 200.2,
    cy: 51.85,
    r: 9.07,
    transform: "translate(116.95 241.16) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-80",
    cx: 161.8,
    cy: 51.85,
    r: 9.07
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 110.73,
    y: 37.85,
    width: 29.46,
    height: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 110.73,
    y: 36.72,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 110.73,
    y: 35.59,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 110.73,
    y: 34.46,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 110.73,
    y: 33.33,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 110.73,
    y: 32.2,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 110.73,
    y: 31.07,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 110.73,
    y: 29.94,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 110.73,
    y: 28.81,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 110.73,
    y: 27.68,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 110.73,
    y: 26.54,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 110.73,
    y: 25.41,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 110.73,
    y: 24.28,
    width: 29.46,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 110.73,
    y: 23.29,
    width: 29.46,
    height: 0.99
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 226.29,
    y: 48.03,
    width: 9.96,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 226.29,
    y: 46.9,
    width: 9.96,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 226.29,
    y: 45.77,
    width: 9.96,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 226.29,
    y: 44.63,
    width: 9.96,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 226.29,
    y: 43.5,
    width: 9.96,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 226.29,
    y: 43.14,
    width: 9.96,
    height: 0.36
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-189"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 15.03,
    y: 48.03,
    width: 9.96,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 15.03,
    y: 46.9,
    width: 9.96,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 15.03,
    y: 45.77,
    width: 9.96,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 15.03,
    y: 44.63,
    width: 9.96,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 15.03,
    y: 43.5,
    width: 9.96,
    height: 1.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 15.03,
    y: 43.14,
    width: 9.96,
    height: 0.36
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 92.59,
    y: 148.05,
    width: 62.63,
    height: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 92.59,
    y: 147.71,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 92.59,
    y: 147.38,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 92.59,
    y: 147.05,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 92.59,
    y: 146.71,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 92.59,
    y: 146.38,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 92.59,
    y: 146.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 92.59,
    y: 145.71,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 92.59,
    y: 145.38,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 92.59,
    y: 145.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 92.59,
    y: 144.71,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 92.59,
    y: 144.38,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 92.59,
    y: 144.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 92.59,
    y: 143.71,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 92.59,
    y: 143.38,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 92.59,
    y: 143.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 92.59,
    y: 142.71,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 92.59,
    y: 142.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 92.59,
    y: 142.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 92.59,
    y: 141.71,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 92.59,
    y: 141.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 92.59,
    y: 141.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 92.59,
    y: 140.71,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 92.59,
    y: 140.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 92.59,
    y: 140.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 92.59,
    y: 139.71,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 92.59,
    y: 139.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 92.59,
    y: 139.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 92.59,
    y: 138.71,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 92.59,
    y: 138.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 92.59,
    y: 138.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 92.59,
    y: 137.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 92.59,
    y: 137.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 92.59,
    y: 137.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 92.59,
    y: 136.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 92.59,
    y: 136.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 92.59,
    y: 136.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 92.59,
    y: 135.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 92.59,
    y: 135.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 92.59,
    y: 135.04,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 92.59,
    y: 134.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 92.59,
    y: 134.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 92.59,
    y: 134.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 92.59,
    y: 133.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 92.59,
    y: 133.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 92.59,
    y: 133.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 92.59,
    y: 132.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 92.59,
    y: 132.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 92.59,
    y: 132.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 92.59,
    y: 131.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 92.59,
    y: 131.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 92.59,
    y: 131.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 92.59,
    y: 130.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 92.59,
    y: 130.37,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 92.59,
    y: 130.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 92.59,
    y: 129.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 92.59,
    y: 129.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 92.59,
    y: 129.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 92.59,
    y: 128.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 92.59,
    y: 128.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 92.59,
    y: 128.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 92.59,
    y: 127.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 92.59,
    y: 127.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 92.59,
    y: 127.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 92.59,
    y: 126.7,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 92.59,
    y: 126.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 92.59,
    y: 126.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 92.59,
    y: 125.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 92.59,
    y: 125.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 92.59,
    y: 125.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 92.59,
    y: 124.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 92.59,
    y: 124.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 92.59,
    y: 124.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 92.59,
    y: 123.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 92.59,
    y: 123.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 92.59,
    y: 123.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 92.59,
    y: 122.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 92.59,
    y: 122.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 92.59,
    y: 122.03,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 92.59,
    y: 121.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 92.59,
    y: 121.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 92.59,
    y: 121.02,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 92.59,
    y: 120.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 92.59,
    y: 120.36,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 92.59,
    y: 120.02,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 92.59,
    y: 119.69,
    width: 62.63,
    height: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 92.59,
    y: 119.57,
    width: 62.63,
    height: 0.12
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLarge);
export default __webpack_public_path__ + "static/media/logo-large.441d17cb057091fc51718e7efb7fc27d.svg";
export { ForwardRef as ReactComponent };